import KitChecklist from './KitChecklist'
import { GetNextVideoSuperVisionMutation_getNextVideoSupervision_videoSupervision } from './__generated__/GetNextVideoSuperVisionMutation'

interface VideoParticipantProps {
  videoSupervision: GetNextVideoSuperVisionMutation_getNextVideoSupervision_videoSupervision
  onComplete: (kitId) => void
  children: React.ReactNode
}

const VideoParticipant = ({ videoSupervision, onComplete, children }: VideoParticipantProps) => {
  return (
    <div className="has-background-info-light px-2 py-2">
      <table className="table is-bordered is-fullwidth">
        <thead>
          <tr>
            <th>Kit Id</th>
            <th>Test</th>
            <th>ID Verification</th>
            <th>Test Verification</th>
          </tr>
        </thead>
        <tbody>
          {videoSupervision.kits.map((kit) => (
            <tr key={kit.id}>
              <KitChecklist
                kitId={kit.id}
                sku={kit.sku}
                orderId={videoSupervision.order.id}
                videoSupervisionId={videoSupervision.id}
                onComplete={() => onComplete(kit.id)}
              />
            </tr>
          ))}
        </tbody>
      </table>

      <div style={{ maxWidth: '858px' }}>{children}</div>
    </div>
  )
}

export default VideoParticipant
